import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import Hidden from "@material-ui/core/Hidden";

const useStyles = makeStyles((theme) => ({
  footer: {
    width: "100%",
    height: "30px",
    marginTop: "30px",
    backgroundColor: "#6f6f6f",
  },
  pku: {
    color: "white",
    "line-height": "26px",
    "font-size": "12px",
    padding: "0 5px",
  },
  copyright: {
    color: "white",
    "line-height": "26px",
    "font-size": "12px",
    padding: "0 5px",
  },
  para: {
    textAlign: "center",
  },
}));

function Footer(props) {
  const classes = useStyles();
  //使用媒介查询,移动端调整footer为两行
  const matches = useMediaQuery("(min-width:600px)");
  return (
    <footer className={classes.footer}>
      {matches ? (
        <p className={classes.para}>
          <span className={classes.copyright}>版权所有©</span>

          <span className={classes.pku}>北京大学考古文博学院张剑葳课题组</span>
          <span className={classes.pku}>北京大学考古虚拟仿真实验教学中心</span>
          <span className={classes.pku}>软件著作权:2019SR0845424</span>
        </p>
      ) : (
        <p className={classes.para}>
          <span className={classes.copyright}>版权所有©</span>
          <span className={classes.pku}>北京大学考古文博学院张剑葳课题组</span>

          <span className={classes.pku}>北京大学考古虚拟仿真实验教学中心</span>
        </p>
      )}
    </footer>
  );
}

export default Footer;
